<template>
	<v-row no-gutters>
		<v-row no-gutters v-if="test.result.note">
			<div style="white-space: pre-line;" class="ma-3">{{test.result.note}}</div>
		</v-row>
		<v-row no-gutters>
			<!-- <template v-for="(o, k) in test.data">
				<v-col v-if="o && ((o.note && o.note != '') || (o.types && o.types.length > 0))" cols="3" :key="k" class="pa-3">
					<p class="ma-0 font-weight-bold">{{getPointName(k)}}</p>
					<v-chip small v-for="t in o.types" :key="t">{{getTypeName(t)}}</v-chip>
					<p class="ma-0" v-if="o.note && o.note != ''">{{o.note}}</p>
				</v-col>
			</template> -->
			<TCMPulseDiagram :test="test" :results="true" :types="types" />
		</v-row>
	</v-row>
</template>

<script>
import TCMPulseDiagram from '@/components/appointment/tests/tcm/TCMPulseDiagram.vue';
import axios from "axios";

export default {
	name: "TCMPulseDetails",
	props: ["test"],
	components: {
		TCMPulseDiagram
	},
	data: () => ({
		types: []
	}),
	methods: {
		getPointName(p) {
			let name = p.slice(0, p.length - 1)
			let side = p.slice(p.length - 1)
			if(side == 'R') name += " - " + this.$gettext("Right");
			else name += " - " + this.$gettext("Left");
			return name.charAt(0).toUpperCase() + name.slice(1);
		},
		getTypeName(t) {
			for(let i = 0; i < this.types.length; i++) {
				if(this.types[i].id == t) return this.types[i].name;
			}
			return "";
		}
	},
	created() {
		axios
			.get("/pulse_types")
			.then(response => {
				console.log(response.data);
				this.types = response.data.pulse_types;
			})
			.catch(error => {
				console.log(error);
			});
	}
}
</script>



